/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Public_AdoptInputs */



/**
* | output |
* | --- |
* | "Moved to the shared bot" |
*
* @param {Activity_Public_AdoptInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_public_adopt = /** @type {((inputs?: Activity_Public_AdoptInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Public_AdoptInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сервер переведён на общего бота")
	return /** @type {LocalizedString} */ ("Moved to the shared bot")
});